<template>
  <div class="boxshell">
    <div class="box">
        <div id="codeDiv" style="display: none;" ref="qrCodeUrl"></div>
      <div class="scanCodeBox">
        <div v-if="type!==1" class="qrcode"  id="qrcode"></div>
        <img class="picture" v-else :src="url" alt="">
      </div>
      <p class="tipTopStyle">{{ tipTop }}</p>
      <p class="tipLowStyle">{{ tipLow }}</p>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';

export default {
  data() {
    return {
      tipTop: '长按识别二维码',
      tipLow: '',
      type: '',
      picture: '',
    };
  },
  mounted() {
    const {
      productId,
    } = this.$route.query;
    console.log('productId', productId);
    this.$api.PublicPage.getScanCode({ productId }).then((res) => {
      console.log('000');
      if (res.success) {
        const {
          url, remark, productName, type,
        } = res.data;
        this.type = type;
        this.tipLow = remark;
        document.title = `${productName}二维码`;
        if (type === 1) {
          this.url = url;
        } else {
          this.creatQrCode(url);
        }
      }
    });
  },
  computed: {},
  methods: {
    creatQrCode(url) {
      const qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: url, // 需要转换为二维码的内容
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H,
      });
      console.log(qrcode);
      const canvas = document.getElementsByTagName('canvas')[0];
      const img = this.convertCanvasToImage(canvas);
      document.getElementById('qrcode').append(img);
    },
    convertCanvasToImage(canvas) {
      // 新建Image对象
      const image = new Image();
      image.style.width = '100%';
      // canvas.toDataURL 返回的是一串Base64编码的URL
      image.src = canvas.toDataURL('image/png');
      return image;
    },
  },
};
</script>
<style scoped>
.picture{
  width: 100%;
  height:100%;
}
.boxshell {
  padding: 0 40px;
  display: flex;
  align-items: center;
  height: 100%;
}
.box {
  width: 100%;
  height: 344px;
  background: #ffffff;
  box-shadow: 0 4px 8px 0 rgba(0, 31, 51, 0.08);
  border-radius: 16px;
  padding-top: 40px;
  box-sizing: border-box;
}
.scanCodeBox {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  box-sizing: border-box;
}
.tipTopStyle {
  font-size: 17px;
  color: #1c2438;
  letter-spacing: 0;
  padding: 0;
  margin: 0;
  margin-top: 16px;
}
.tipLowStyle {
  font-size: 14px;
  color: #495060;
  letter-spacing: 0;
  padding: 0;
  margin: 0;
  margin-top: 4px;
  padding-left: 30px;
  padding-right: 30px;
  box-sizing: border-box;
}
</style>
